import React, { useContext } from 'react';
import { Button, Separator, Text } from 'telia-front-react';
import config from '../Config';
import { RootStoreContext } from '../stores/RootStore';
const PrivacyPageLink = () => {
    const { translateStore: { translate } } = useContext(RootStoreContext);
    return (React.createElement(Text, null,
        React.createElement("p", null, translate('privacyPageLink.description')),
        React.createElement(Separator, { spacing: 'xxsmall', color: 'invisible' }),
        React.createElement(Button, { text: translate('privacyPageLink.link'), url: `${config.ssoTransferSessionUrl}${config.teliaSelfServiceUrl}/konto/pakkumiste-ja-uudiste-seaded?goToUrl=${config.diilCrmUrl}/konto`, iconRight: '#new-window' })));
};
export default PrivacyPageLink;
